import React, { useCallback, useState, useEffect } from 'react';
import { useGame } from '../context/GameContext.jsx';

const TopBar = ({ currentCounter }) => {
  const { sessionId, translations, lang, setError } = useGame();

  const [displaySessionCode, setDisplaySessionCode] = useState(`#${sessionId || translations[lang]?.session_code_na}`);
  const [isCopiedTextVisible, setIsCopiedTextVisible] = useState(false);
  const copyTimeoutRef = React.useRef(null);

  useEffect(() => {
    if (!isCopiedTextVisible) {
      setDisplaySessionCode(`#${sessionId || translations[lang]?.session_code_na}`);
    }
  }, [sessionId, isCopiedTextVisible, lang, translations]);

  const handleGoHome = useCallback(() => {
    window.location.hash = '';
  }, []);

  const handleCopySessionId = useCallback(async () => {
    if (sessionId && sessionId !== translations[lang]?.session_code_na) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(sessionId);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = sessionId;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }

        if (copyTimeoutRef.current) {
          clearTimeout(copyTimeoutRef.current);
        }

        setIsCopiedTextVisible(true);
        setDisplaySessionCode(translations[lang]?.copied_text_label);

        copyTimeoutRef.current = setTimeout(() => {
          setIsCopiedTextVisible(false);
          setTimeout(() => {
            setDisplaySessionCode(`#${sessionId || translations[lang]?.session_code_na}`);
          }, 500);
        }, 3000);
      } catch (err) {
        console.error('Failed to copy:', err);
        setError(translations[lang]?.copy_failed_error);
      }
    }
  }, [sessionId, translations, lang, setError]);

  const renderCounterBadge = useCallback(() => {
    if (currentCounter === null || currentCounter === undefined) {
      return null;
    }
    let badgeClass = 'bg-primary'; 
    if (currentCounter <= 12) {
      badgeClass = 'bg-danger'; 
    }
    return (
      <span className={`badge ${badgeClass} top-bar-counter-badge`}>
        <i className="fa-regular fa-hourglass-half me-1"></i>{' '}
        {currentCounter}
      </span>
    );
  }, [currentCounter]);

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <i className="fas fa-home home-icon" onClick={handleGoHome} title={translations[lang]?.home_button_label}></i>
      </div>
      <div className="top-bar-center">
        <span 
          className={`session-code-box ${isCopiedTextVisible ? 'copied-fade-in' : 'copied-fade-out'}`}
          onClick={handleCopySessionId}
        >
          {displaySessionCode}
        </span>
      </div>
      <div className="top-bar-right">
        {renderCounterBadge()}
      </div>
    </div>
  );
};

export default TopBar;
